
import { Vue, Component, Prop, Model, Emit } from 'vue-property-decorator';
import ItemChip from '@/components/common/ItemChip.vue';
import S3Image from '@/components/common/s3-image.vue';
import { hslColorFromName } from "@/utils/hslColorFromName";
@Component({
	components: {
		ItemChip,
		S3Image,
	},
})
export default class DataTable extends Vue {
	@Prop({ type: Array, required: true }) headers!: Array<{
		text: string;
		value: string;
		badge?: boolean;
	}>;
	@Prop({ type: Array, required: true }) data!: Array<Record<string, any>>;
	@Prop({ type: Boolean, default: false }) isInPopup!: boolean;

	handleCancel(): void {
		this.$emit('input', false);
	}

	get defaultImageClasses(): string {
		return 'inline-block rounded-full object-cover object-center';
	}

	get getAvatrClass() {
		return 'chipHeight flex-shrink-0 circleWidth rounded-full bg-primary-500 flex items-center text-xs justify-center text-white';
	}

  initial(item): string {
    const firstName = item.user?.given_name;
    const lastName = item.user?.family_name;

    if (!firstName && !lastName) {
      return ''
    }

    const givenName = firstName ? firstName.trimLeft()[0] : '';
    const familyName = lastName ? lastName.trimLeft()[0] : '';
    return `${givenName}${familyName}`;
  }

  bgStyle(item): object {
      return {
          background: hslColorFromName(this.initial(item) || ""),
      };
  }

}
